import { render, staticRenderFns } from "./AxFilesystemViewerActions.vue?vue&type=template&id=4845e524&"
import script from "./AxFilesystemViewerActions.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemViewerActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports